import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const routes = [
   {
      path: "/", redirect: "/create-report", component: () => import("@/view/layout/Layout"), children: [
         {
            path: "/create-report",
            name: "create_report",
            component: () => import("@/view/pages/CreateReport.vue")
         },
         {
            path: "/my-reports",
            name: "my_reports",
            component: () => import("@/view/pages/MyReports.vue")
         },
         {
            path: "/analysis",
            name: "analysis",
            component: () => import("@/view/pages/Analysis.vue")
         },
         {
            path: "/my-analysis",
            name: "my-analysis",
            component: () => import("@/view/pages/MyAnalysis.vue")
         },
      ]
   },
   {
      path: "/",
      component: () => import("@/view/pages/auth/Auth"), children: [
         {
            name: "login",
            path: "/login",
            component: () => import("@/view/pages/auth/Login")
         },
         {
            name: "register",
            path: "/register",
            component: () => import("@/view/pages/auth/Register")
         }
      ]
   },
   {
      path: "/", redirect: "/create-report", component: () => import("@/view/layout/InvitationLayout"), children: [
         {
            name: "invitation",
            path: "/signproof/invitation/:invid",
            component: () => import("@/view/pages/Invitation"),
            props: true
         }
      ]
   },
   {
      path: "*",
      redirect: "/404",
   },
   {
      path: '/404',
      name: '404',
      component: () => import("@/view/pages/error/Error-1.vue")
   }
];


export default new Router({mode: 'history', routes});
